import { TableState } from '@tanstack/react-table';
import { useMemo } from 'react';
import { BookingRequestRead, BookingRequestReadStatusEnum } from '../../../api';
import { SortDataPayload } from '../../models/sort';
import { BookingRequestsFiltersState } from '../BookingRequestsFilters';
import { ListFooter } from '../ListFooter';
import { Table } from '../Table';
import { useColumns } from './useColumns';

interface ShiftRequestsTableProps {
  isLoading: boolean;
  list?: BookingRequestRead[];
  pageSize: number;
  totalCount: number;
  currentPage: number;
  isProvider: boolean;
  statusFilter?: BookingRequestReadStatusEnum[];
  filters: BookingRequestsFiltersState;
  handleChangePage: (page: number) => void;
  onRowClick: (row: BookingRequestRead) => void;
  onUpdateSort: (data: SortDataPayload) => void;
}

export const ShiftRequestsTable = ({
  isLoading,
  list,
  pageSize,
  totalCount,
  currentPage,
  handleChangePage,
  isProvider,
  onRowClick,
  onUpdateSort,
  filters,
}: ShiftRequestsTableProps) => {
  const columns = useColumns({ isProvider, filters, onSetSort: onUpdateSort });

  const state: Partial<TableState> = useMemo(
    () => ({
      // columnPinning: {
      //   left: ['facility'],
      //   right: [],
      // },
      columnVisibility: {
        provider: !isProvider,
      },
    }),
    [isProvider]
  );

  return (
    <div className="card border w-100 rounded bg-white shadow mb-6 table-requests">
      <Table
        isLoading={isLoading}
        columns={columns}
        state={state}
        data={list as []}
        size={pageSize}
        onRowClick={onRowClick}
        tableClassName="fs-14 global_table-action-row"
      />

      <ListFooter
        title="Assignment"
        totalCount={totalCount}
        pageSize={pageSize}
        currentPage={currentPage}
        onChangePage={handleChangePage}
        containerClassName="py-3 px-2 text-muted"
      />
    </div>
  );
};
